import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=585e5157"
import script from "./DashboardIndex.vue?vue&type=script&lang=js"
export * from "./DashboardIndex.vue?vue&type=script&lang=js"
import style0 from "./DashboardIndex.vue?vue&type=style&index=0&id=585e5157&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports